import { jsxs as g, Fragment as K, jsx as c } from "react/jsx-runtime";
import * as m from "react";
import $e, { createContext as ke, useState as ue, useContext as Re, useRef as Le, useEffect as te } from "react";
function Ee(n) {
  return n && n.__esModule && Object.prototype.hasOwnProperty.call(n, "default") ? n.default : n;
}
var q = {}, fe;
function Fe() {
  if (fe) return q;
  fe = 1;
  var n = $e;
  function h(r) {
    return r && typeof r == "object" && "default" in r ? r : { default: r };
  }
  var d = /* @__PURE__ */ h(n);
  function u(r, s) {
    for (var l = 0; l < s.length; l++) {
      var e = s[l];
      e.enumerable = e.enumerable || !1, e.configurable = !0, "value" in e && (e.writable = !0), Object.defineProperty(r, e.key, e);
    }
  }
  function f(r, s, l) {
    return s && u(r.prototype, s), r;
  }
  var C = typeof process < "u" && process.env && process.env.NODE_ENV === "production", v = function(r) {
    return Object.prototype.toString.call(r) === "[object String]";
  }, M = /* @__PURE__ */ function() {
    function r(l) {
      var e = l === void 0 ? {} : l, o = e.name, i = o === void 0 ? "stylesheet" : o, a = e.optimizeForSpeed, p = a === void 0 ? C : a;
      _(v(i), "`name` must be a string"), this._name = i, this._deletedRulePlaceholder = "#" + i + "-deleted-rule____{}", _(typeof p == "boolean", "`optimizeForSpeed` must be a boolean"), this._optimizeForSpeed = p, this._serverSheet = void 0, this._tags = [], this._injected = !1, this._rulesCount = 0;
      var B = typeof window < "u" && document.querySelector('meta[property="csp-nonce"]');
      this._nonce = B ? B.getAttribute("content") : null;
    }
    var s = r.prototype;
    return s.setOptimizeForSpeed = function(e) {
      _(typeof e == "boolean", "`setOptimizeForSpeed` accepts a boolean"), _(this._rulesCount === 0, "optimizeForSpeed cannot be when rules have already been inserted"), this.flush(), this._optimizeForSpeed = e, this.inject();
    }, s.isOptimizeForSpeed = function() {
      return this._optimizeForSpeed;
    }, s.inject = function() {
      var e = this;
      if (_(!this._injected, "sheet already injected"), this._injected = !0, typeof window < "u" && this._optimizeForSpeed) {
        this._tags[0] = this.makeStyleTag(this._name), this._optimizeForSpeed = "insertRule" in this.getSheet(), this._optimizeForSpeed || (C || console.warn("StyleSheet: optimizeForSpeed mode not supported falling back to standard mode."), this.flush(), this._injected = !0);
        return;
      }
      this._serverSheet = {
        cssRules: [],
        insertRule: function(o, i) {
          return typeof i == "number" ? e._serverSheet.cssRules[i] = {
            cssText: o
          } : e._serverSheet.cssRules.push({
            cssText: o
          }), i;
        },
        deleteRule: function(o) {
          e._serverSheet.cssRules[o] = null;
        }
      };
    }, s.getSheetForTag = function(e) {
      if (e.sheet)
        return e.sheet;
      for (var o = 0; o < document.styleSheets.length; o++)
        if (document.styleSheets[o].ownerNode === e)
          return document.styleSheets[o];
    }, s.getSheet = function() {
      return this.getSheetForTag(this._tags[this._tags.length - 1]);
    }, s.insertRule = function(e, o) {
      if (_(v(e), "`insertRule` accepts only strings"), typeof window > "u")
        return typeof o != "number" && (o = this._serverSheet.cssRules.length), this._serverSheet.insertRule(e, o), this._rulesCount++;
      if (this._optimizeForSpeed) {
        var i = this.getSheet();
        typeof o != "number" && (o = i.cssRules.length);
        try {
          i.insertRule(e, o);
        } catch {
          return C || console.warn(`StyleSheet: illegal rule: 

` + e + `

See https://stackoverflow.com/q/20007992 for more info`), -1;
        }
      } else {
        var a = this._tags[o];
        this._tags.push(this.makeStyleTag(this._name, e, a));
      }
      return this._rulesCount++;
    }, s.replaceRule = function(e, o) {
      if (this._optimizeForSpeed || typeof window > "u") {
        var i = typeof window < "u" ? this.getSheet() : this._serverSheet;
        if (o.trim() || (o = this._deletedRulePlaceholder), !i.cssRules[e])
          return e;
        i.deleteRule(e);
        try {
          i.insertRule(o, e);
        } catch {
          C || console.warn(`StyleSheet: illegal rule: 

` + o + `

See https://stackoverflow.com/q/20007992 for more info`), i.insertRule(this._deletedRulePlaceholder, e);
        }
      } else {
        var a = this._tags[e];
        _(a, "old rule at index `" + e + "` not found"), a.textContent = o;
      }
      return e;
    }, s.deleteRule = function(e) {
      if (typeof window > "u") {
        this._serverSheet.deleteRule(e);
        return;
      }
      if (this._optimizeForSpeed)
        this.replaceRule(e, "");
      else {
        var o = this._tags[e];
        _(o, "rule at index `" + e + "` not found"), o.parentNode.removeChild(o), this._tags[e] = null;
      }
    }, s.flush = function() {
      this._injected = !1, this._rulesCount = 0, typeof window < "u" ? (this._tags.forEach(function(e) {
        return e && e.parentNode.removeChild(e);
      }), this._tags = []) : this._serverSheet.cssRules = [];
    }, s.cssRules = function() {
      var e = this;
      return typeof window > "u" ? this._serverSheet.cssRules : this._tags.reduce(function(o, i) {
        return i ? o = o.concat(Array.prototype.map.call(e.getSheetForTag(i).cssRules, function(a) {
          return a.cssText === e._deletedRulePlaceholder ? null : a;
        })) : o.push(null), o;
      }, []);
    }, s.makeStyleTag = function(e, o, i) {
      o && _(v(o), "makeStyleTag accepts only strings as second parameter");
      var a = document.createElement("style");
      this._nonce && a.setAttribute("nonce", this._nonce), a.type = "text/css", a.setAttribute("data-" + e, ""), o && a.appendChild(document.createTextNode(o));
      var p = document.head || document.getElementsByTagName("head")[0];
      return i ? p.insertBefore(a, i) : p.appendChild(a), a;
    }, f(r, [
      {
        key: "length",
        get: function() {
          return this._rulesCount;
        }
      }
    ]), r;
  }();
  function _(r, s) {
    if (!r)
      throw new Error("StyleSheet: " + s + ".");
  }
  function R(r) {
    for (var s = 5381, l = r.length; l; )
      s = s * 33 ^ r.charCodeAt(--l);
    return s >>> 0;
  }
  var z = R, L = function(r) {
    return r.replace(/\/style/gi, "\\/style");
  }, b = {};
  function N(r, s) {
    if (!s)
      return "jsx-" + r;
    var l = String(s), e = r + l;
    return b[e] || (b[e] = "jsx-" + z(r + "-" + l)), b[e];
  }
  function j(r, s) {
    var l = /__jsx-style-dynamic-selector/g;
    typeof window > "u" && (s = L(s));
    var e = r + s;
    return b[e] || (b[e] = s.replace(l, r)), b[e];
  }
  function D(r, s) {
    return s === void 0 && (s = {}), r.map(function(l) {
      var e = l[0], o = l[1];
      return /* @__PURE__ */ d.default.createElement("style", {
        id: "__" + e,
        // Avoid warnings upon render with a key
        key: "__" + e,
        nonce: s.nonce ? s.nonce : void 0,
        dangerouslySetInnerHTML: {
          __html: o
        }
      });
    });
  }
  var t = /* @__PURE__ */ function() {
    function r(l) {
      var e = l === void 0 ? {} : l, o = e.styleSheet, i = o === void 0 ? null : o, a = e.optimizeForSpeed, p = a === void 0 ? !1 : a;
      this._sheet = i || new M({
        name: "styled-jsx",
        optimizeForSpeed: p
      }), this._sheet.inject(), i && typeof p == "boolean" && (this._sheet.setOptimizeForSpeed(p), this._optimizeForSpeed = this._sheet.isOptimizeForSpeed()), this._fromServer = void 0, this._indices = {}, this._instancesCounts = {};
    }
    var s = r.prototype;
    return s.add = function(e) {
      var o = this;
      this._optimizeForSpeed === void 0 && (this._optimizeForSpeed = Array.isArray(e.children), this._sheet.setOptimizeForSpeed(this._optimizeForSpeed), this._optimizeForSpeed = this._sheet.isOptimizeForSpeed()), typeof window < "u" && !this._fromServer && (this._fromServer = this.selectFromServer(), this._instancesCounts = Object.keys(this._fromServer).reduce(function(E, V) {
        return E[V] = 0, E;
      }, {}));
      var i = this.getIdAndRules(e), a = i.styleId, p = i.rules;
      if (a in this._instancesCounts) {
        this._instancesCounts[a] += 1;
        return;
      }
      var B = p.map(function(E) {
        return o._sheet.insertRule(E);
      }).filter(function(E) {
        return E !== -1;
      });
      this._indices[a] = B, this._instancesCounts[a] = 1;
    }, s.remove = function(e) {
      var o = this, i = this.getIdAndRules(e).styleId;
      if (A(i in this._instancesCounts, "styleId: `" + i + "` not found"), this._instancesCounts[i] -= 1, this._instancesCounts[i] < 1) {
        var a = this._fromServer && this._fromServer[i];
        a ? (a.parentNode.removeChild(a), delete this._fromServer[i]) : (this._indices[i].forEach(function(p) {
          return o._sheet.deleteRule(p);
        }), delete this._indices[i]), delete this._instancesCounts[i];
      }
    }, s.update = function(e, o) {
      this.add(o), this.remove(e);
    }, s.flush = function() {
      this._sheet.flush(), this._sheet.inject(), this._fromServer = void 0, this._indices = {}, this._instancesCounts = {};
    }, s.cssRules = function() {
      var e = this, o = this._fromServer ? Object.keys(this._fromServer).map(function(a) {
        return [
          a,
          e._fromServer[a]
        ];
      }) : [], i = this._sheet.cssRules();
      return o.concat(Object.keys(this._indices).map(function(a) {
        return [
          a,
          e._indices[a].map(function(p) {
            return i[p].cssText;
          }).join(e._optimizeForSpeed ? "" : `
`)
        ];
      }).filter(function(a) {
        return !!a[1];
      }));
    }, s.styles = function(e) {
      return D(this.cssRules(), e);
    }, s.getIdAndRules = function(e) {
      var o = e.children, i = e.dynamic, a = e.id;
      if (i) {
        var p = N(a, i);
        return {
          styleId: p,
          rules: Array.isArray(o) ? o.map(function(B) {
            return j(p, B);
          }) : [
            j(p, o)
          ]
        };
      }
      return {
        styleId: N(a),
        rules: Array.isArray(o) ? o : [
          o
        ]
      };
    }, s.selectFromServer = function() {
      var e = Array.prototype.slice.call(document.querySelectorAll('[id^="__jsx-"]'));
      return e.reduce(function(o, i) {
        var a = i.id.slice(2);
        return o[a] = i, o;
      }, {});
    }, r;
  }();
  function A(r, s) {
    if (!r)
      throw new Error("StyleSheetRegistry: " + s + ".");
  }
  var y = /* @__PURE__ */ n.createContext(null);
  y.displayName = "StyleSheetContext";
  function $() {
    return new t();
  }
  function I(r) {
    var s = r.registry, l = r.children, e = n.useContext(y), o = n.useState(function() {
      return e || s || $();
    }), i = o[0];
    return /* @__PURE__ */ d.default.createElement(y.Provider, {
      value: i
    }, l);
  }
  function T() {
    return n.useContext(y);
  }
  var W = d.default.useInsertionEffect || d.default.useLayoutEffect, U = typeof window < "u" ? $() : void 0;
  function H(r) {
    var s = U || T();
    return s ? typeof window > "u" ? (s.add(r), null) : (W(function() {
      return s.add(r), function() {
        s.remove(r);
      };
    }, [
      r.id,
      String(r.dynamic)
    ]), null) : null;
  }
  return H.dynamic = function(r) {
    return r.map(function(s) {
      var l = s[0], e = s[1];
      return N(l, e);
    }).join(" ");
  }, q.StyleRegistry = I, q.createStyleRegistry = $, q.style = H, q.useStyleRegistry = T, q;
}
var Y, pe;
function ze() {
  return pe || (pe = 1, Y = Fe().style), Y;
}
var Ne = ze();
const G = /* @__PURE__ */ Ee(Ne), Ae = "#00335D", Te = "#E6F1FA", Pe = "#eff6ff", Me = "#bfdbfe", Be = "#2563eb", Oe = "#f0fdf4", Ze = "#bbf7d0", De = "#16a34a", Ie = "#007f2A", qe = "#DAFEE3", me = "#105726", xe = "#343e49", ee = "#BC001C", We = "#fecaca", He = "#721C24", Ve = "#FFDDE4", Ge = "#63000F", J = "#fefeff", k = "#333333", Je = "#1d1d1d", ge = "#FFF1C9", Ue = "#fef08a", Xe = "#73580D", Qe = "#FDDE00", F = "'Lato', sans-serif", Q = "12px", Ke = "14px", Ye = "24px", et = 170, x = [".wholesale-banner-container.jsx-464117352{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;}", `.banner-active-promotions.jsx-464117352{gap:4px;color:${Ie};margin-bottom:4px;font-family:${F};font-size:${Q};font-style:normal;font-weight:400;}`, ".quantity-promotions.jsx-464117352{font-weight:700;}", `.banner-add-products.jsx-464117352{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:4px;color:${Ae};line-height:16px;padding:7px 8px;font-family:${F};font-size:${Q};font-style:normal;font-weight:400;background-color:${Te};border-radius:4px;}`, ".discount-icon-container.jsx-464117352{width:16px;height:16px;}", ".discount-icon-container.isDesktop.jsx-464117352{width:20px;height:20px;}", ".add-products-text.jsx-464117352{font-weight:700;}", ".add-products-text.clickable.jsx-464117352{-webkit-text-decoration:underline;text-decoration:underline;cursor:pointer;}", `.add-products-button.jsx-464117352{cursor:pointer;padding:4px 12px;margin:0 0 0 auto;border-radius:4px;border:1.5px solid ${xe};background:${J};color:${xe};font-family:${F};font-size:12px;font-weight:700;}`, `.banner-ready.jsx-464117352{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:4px;color:${me};padding:7px 8px;font-family:${F};font-size:${Q};line-height:16px;font-style:normal;font-weight:400;background-color:${qe};border-radius:4px;}`, ".ready.jsx-464117352{font-weight:700;}", `.toast-text.jsx-464117352{color:${me};font-family:${F};}`];
x.__hash = "464117352";
const tt = (n) => /* @__PURE__ */ m.createElement("svg", { viewBox: "0 0 15 15", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...n }, /* @__PURE__ */ m.createElement("path", { d: "M14.2929 9.77981L13.7062 7.96648C13.6795 7.87981 13.6795 7.79314 13.7062 7.70648L14.2862 5.91314C14.5062 5.23314 14.2062 4.50648 13.5662 4.17981L11.8862 3.31981C11.8062 3.27981 11.7462 3.21981 11.7062 3.13981L10.8395 1.43981C10.5195 0.813143 9.80619 0.519809 9.13953 0.733142L7.32619 1.31981C7.24619 1.34648 7.15285 1.34648 7.07285 1.31981L5.25952 0.733142C4.59285 0.519809 3.87952 0.813143 3.55952 1.43981L2.69285 3.13981C2.65285 3.21981 2.58619 3.27981 2.51286 3.31981L0.812855 4.18648C0.186188 4.50648 -0.107144 5.21981 0.10619 5.88648L0.692849 7.69981C0.719516 7.78648 0.719516 7.87314 0.692849 7.95981L0.10619 9.77314C-0.107144 10.4398 0.186188 11.1531 0.812855 11.4731L2.51286 12.3398C2.59286 12.3798 2.65285 12.4465 2.69285 12.5198L3.55952 14.2198C3.87952 14.8465 4.59285 15.1398 5.25952 14.9265L7.07285 14.3398C7.15952 14.3131 7.24619 14.3131 7.33285 14.3398L9.14619 14.9265C9.29286 14.9731 9.43952 14.9998 9.58619 14.9998C10.1062 14.9998 10.5995 14.7131 10.8462 14.2265L11.7129 12.5265C11.7529 12.4465 11.8195 12.3865 11.8929 12.3465L13.5929 11.4798C14.2195 11.1598 14.5129 10.4465 14.2995 9.77981H14.2929ZM13.1329 10.5865L11.4328 11.4531C11.1662 11.5931 10.9529 11.8065 10.8129 12.0731L9.94619 13.7731C9.85285 13.9598 9.63952 14.0465 9.44619 13.9798L7.63285 13.3931C7.49285 13.3465 7.34619 13.3265 7.19952 13.3265C7.05286 13.3265 6.90619 13.3465 6.75952 13.3931L4.94619 13.9798C4.75285 14.0465 4.53952 13.9531 4.44619 13.7731L3.57952 12.0731C3.43952 11.8065 3.22619 11.5931 2.95952 11.4531L1.25952 10.5865C1.07285 10.4931 0.986188 10.2798 1.05286 10.0865L1.63952 8.27314C1.73286 7.98648 1.73286 7.68648 1.63952 7.39981L1.05286 5.58648C0.986188 5.38648 1.07952 5.17981 1.25952 5.08648L2.95952 4.21981C3.22619 4.07981 3.43952 3.86648 3.57952 3.59981L4.44619 1.89981C4.53952 1.71314 4.75285 1.62648 4.94619 1.69314L6.75952 2.27981C7.03952 2.37314 7.35285 2.37314 7.63285 2.27981L9.44619 1.69314C9.64619 1.62648 9.85285 1.71981 9.94619 1.89981L10.8129 3.59981C10.9529 3.86648 11.1662 4.07981 11.4328 4.21981L13.1129 5.07981C13.3062 5.17981 13.3995 5.40648 13.3329 5.61314L12.7529 7.40648C12.6595 7.69314 12.6595 7.99314 12.7529 8.27981L13.3395 10.0931C13.4062 10.2865 13.3129 10.4998 13.1329 10.5931V10.5865Z", fill: "currentColor" }), /* @__PURE__ */ m.createElement("path", { d: "M8.83952 5.47981L4.83952 9.47981C4.64619 9.67314 4.64619 9.99314 4.83952 10.1865C4.93952 10.2865 5.06618 10.3331 5.19285 10.3331C5.31952 10.3331 5.44619 10.2865 5.54619 10.1865L9.54619 6.18648C9.73953 5.99314 9.73953 5.67314 9.54619 5.47981C9.35286 5.28648 9.03285 5.28648 8.83952 5.47981Z", fill: "currentColor" }), /* @__PURE__ */ m.createElement("path", { d: "M5.35952 6.66648C5.72618 6.66648 6.02618 6.36648 6.02618 5.99981C6.02618 5.63314 5.72618 5.33314 5.35952 5.33314C5.17952 5.33314 5.01286 5.39981 4.88619 5.53314C4.75952 5.65981 4.69285 5.82648 4.69285 5.99981C4.69285 6.36648 4.99285 6.66648 5.35952 6.66648Z", fill: "currentColor" }), /* @__PURE__ */ m.createElement("path", { d: "M9.02618 8.99981C8.84618 8.99981 8.67952 9.06648 8.55286 9.19981C8.42619 9.32648 8.35952 9.49314 8.35952 9.66648C8.35952 10.0331 8.65952 10.3331 9.02618 10.3331C9.39285 10.3331 9.69285 10.0331 9.69285 9.66648C9.69285 9.29981 9.39285 8.99981 9.02618 8.99981Z", fill: "currentColor" })), Ce = (n) => /* @__PURE__ */ m.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 36 24", fill: "none", stroke: "currentColor", strokeWidth: 2.5, ...n }, /* @__PURE__ */ m.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "M1.25 12 L12 22.75 L34.75 1.25" })), X = "12px", Z = [`.toast.jsx-920869864{box-sizing:border-box;width:320px;max-width:calc(100svw - 2 * ${X} - 20px);max-height:calc(100svh - 2 * ${X} - 20px);padding:18px ${X};display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;gap:14px;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;position:relative;border-radius:4px;background:${ge};box-shadow:0px 4px 20px 0px ${Je}33;overflow:hidden;-webkit-animation:toast-render-animation-jsx-920869864 0.5s 1;animation:toast-render-animation-jsx-920869864 0.5s 1;}`, `.toast.success.jsx-920869864{background-color:${Oe};border-color:${Ze};color:${De};}`, `.toast.information.jsx-920869864{background-color:${Pe};border-color:${Me};color:${Be};}`, `.toast.warning.jsx-920869864{background-color:${ge};border-color:${Ue};color:${Xe};}`, `.toast.error.jsx-920869864{background-color:${Ve};border-color:${We};color:${Ge};gap:6px;-webkit-align-items:start;-webkit-box-align:start;-ms-flex-align:start;align-items:start;padding:${X};}`, `.toast.neutral.jsx-920869864{background-color:${k};border-color:${k};color:${J};}`, `.text.success.jsx-920869864{color:${k};}`, `.text.information.jsx-920869864{color:${k};}`, `.text.warning.jsx-920869864{color:${k};}`, `.text.error.jsx-920869864{color:${He};line-height:20px;-webkit-letter-spacing:0;-moz-letter-spacing:0;-ms-letter-spacing:0;letter-spacing:0;paragraph-spacing:8px;}`, `.text.neutral.jsx-920869864{color:${J};}`, ".close-button.jsx-920869864{position:absolute;top:10px;right:10px;cursor:pointer;height:12px;width:12px;min-height:12px;min-width:12px;background:none;border:none;padding:0;color:inherit;}", `.text.jsx-920869864{font-family:${F};color:${k};font-size:14px;font-style:normal;font-weight:400;padding-right:15px;line-height:16px;margin:0;}`, "@-webkit-keyframes toast-render-animation-jsx-920869864{0%{position:relative;top:20px;opacity:0;}100%{position:relative;top:0;opacity:1;}}", "@keyframes toast-render-animation-jsx-920869864{0%{position:relative;top:20px;opacity:0;}100%{position:relative;top:0;opacity:1;}}"];
Z.__hash = "920869864";
const nt = (n) => /* @__PURE__ */ m.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 2, ...n }, /* @__PURE__ */ m.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "M1 1 L23 23" }), /* @__PURE__ */ m.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "M23 1 L1 23" })), ve = (n) => /* @__PURE__ */ m.createElement("svg", { viewBox: "0 0 21 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...n }, /* @__PURE__ */ m.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.5 1.75C5.94365 1.75 2.25 5.44365 2.25 10C2.25 14.5563 5.94365 18.25 10.5 18.25C15.0563 18.25 18.75 14.5563 18.75 10C18.75 5.44365 15.0563 1.75 10.5 1.75ZM0.75 10C0.75 4.61522 5.11522 0.25 10.5 0.25C15.8848 0.25 20.25 4.61522 20.25 10C20.25 15.3848 15.8848 19.75 10.5 19.75C5.11522 19.75 0.75 15.3848 0.75 10Z", fill: "currentColor" }), /* @__PURE__ */ m.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.5 12.25C11.1213 12.25 11.625 12.7537 11.625 13.375C11.625 13.9963 11.1213 14.5 10.5 14.5C9.87868 14.5 9.375 13.9963 9.375 13.375C9.375 12.7537 9.87868 12.25 10.5 12.25ZM11.25 10C11.25 10.4142 10.9142 10.75 10.5 10.75C10.0858 10.75 9.75 10.4142 9.75 10V6.25C9.75 5.83579 10.0858 5.5 10.5 5.5C10.9142 5.5 11.25 5.83579 11.25 6.25V10Z", fill: "currentColor" })), ot = (n) => /* @__PURE__ */ m.createElement("svg", { viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...n }, /* @__PURE__ */ m.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.11101 12.8203C4.26215 13.5895 5.61553 14 7 14C8.85652 14 10.637 13.2625 11.9497 11.9497C13.2625 10.637 14 8.85652 14 7C14 5.61553 13.5895 4.26215 12.8203 3.11101C12.0511 1.95987 10.9579 1.06266 9.67879 0.532846C8.3997 0.00303296 6.99224 -0.13559 5.63437 0.134506C4.2765 0.404603 3.02922 1.07129 2.05026 2.05026C1.07129 3.02922 0.404603 4.2765 0.134506 5.63437C-0.13559 6.99224 0.00303296 8.3997 0.532846 9.67879C1.06266 10.9579 1.95987 12.0511 3.11101 12.8203ZM3.75918 2.14976C4.71846 1.50879 5.84628 1.16667 7 1.16667C8.5471 1.16667 10.0308 1.78125 11.1248 2.87521C12.2188 3.96918 12.8333 5.45291 12.8333 7C12.8333 8.15373 12.4912 9.28154 11.8502 10.2408C11.2093 11.2001 10.2982 11.9478 9.23232 12.3893C8.16642 12.8308 6.99353 12.9463 5.86198 12.7212C4.73042 12.4962 3.69102 11.9406 2.87521 11.1248C2.05941 10.309 1.50384 9.26958 1.27876 8.13803C1.05367 7.00647 1.16919 5.83358 1.61071 4.76768C2.05222 3.70178 2.79989 2.79074 3.75918 2.14976ZM7.00002 4.8611C6.84594 4.85908 6.69873 4.79698 6.58977 4.68801C6.48081 4.57905 6.4187 4.43185 6.41669 4.27776V3.88888C6.41669 3.73417 6.47815 3.58579 6.58754 3.4764C6.69694 3.367 6.84531 3.30554 7.00002 3.30554C7.15473 3.30554 7.3031 3.367 7.4125 3.4764C7.52189 3.58579 7.58335 3.73417 7.58335 3.88888V4.27776C7.58134 4.43185 7.51923 4.57905 7.41027 4.68801C7.30131 4.79698 7.1541 4.85908 7.00002 4.8611ZM7.00002 10.6945C6.84594 10.6925 6.69873 10.6304 6.58977 10.5214C6.48081 10.4124 6.4187 10.2652 6.41669 10.1111V6.22225C6.41669 6.06754 6.47815 5.91917 6.58754 5.80977C6.69694 5.70037 6.84531 5.63892 7.00002 5.63892C7.15473 5.63892 7.3031 5.70037 7.4125 5.80977C7.52189 5.91917 7.58335 6.06754 7.58335 6.22225V10.1111C7.58134 10.2652 7.51923 10.4124 7.41027 10.5214C7.30131 10.6304 7.1541 10.6925 7.00002 10.6945Z", fill: "currentColor" })), st = (n) => /* @__PURE__ */ m.createElement("svg", { viewBox: "0 0 20 19", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...n }, /* @__PURE__ */ m.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.6306 8.72219C13.2984 8.05309 14.3812 8.05421 15.0489 8.72194L19.1702 12.8432C19.4631 13.1361 19.4631 13.611 19.1702 13.9039C18.8773 14.1968 18.4024 14.1968 18.1095 13.9039L13.9883 9.78261C13.9054 9.69976 13.7731 9.70074 13.6922 9.78193L9.57019 13.9039C9.2773 14.1968 8.80243 14.1968 8.50953 13.9039C8.21664 13.611 8.21664 13.1361 8.50953 12.8432L12.6306 8.72219Z", fill: "currentColor" }), /* @__PURE__ */ m.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.23986 1.64355C3.06336 1.64355 2.10986 2.59705 2.10986 3.77355V15.2936C2.10986 16.4701 3.06336 17.4236 4.23986 17.4236H15.7599C16.9364 17.4236 17.8899 16.4701 17.8899 15.2936V3.77355C17.8899 2.59705 16.9364 1.64355 15.7599 1.64355H4.23986ZM0.609863 3.77355C0.609863 1.76862 2.23493 0.143555 4.23986 0.143555H15.7599C17.7648 0.143555 19.3899 1.76862 19.3899 3.77355V15.2936C19.3899 17.2985 17.7648 18.9236 15.7599 18.9236H4.23986C2.23493 18.9236 0.609863 17.2985 0.609863 15.2936V3.77355Z", fill: "currentColor" }), /* @__PURE__ */ m.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.91057 11.6022C6.57842 10.9331 7.66118 10.9342 8.32891 11.6019L14.3702 17.6432C14.6631 17.9361 14.6631 18.411 14.3702 18.7039C14.0773 18.9968 13.6024 18.9968 13.3095 18.7039L7.26825 12.6626C7.18541 12.5798 7.05313 12.5807 6.97215 12.6619L2.31835 17.3157C2.02546 17.6086 1.55059 17.6086 1.25769 17.3157C0.9648 17.0228 0.9648 16.548 1.25769 16.2551L5.91057 11.6022Z", fill: "currentColor" }), /* @__PURE__ */ m.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.33498 5.86866C6.76846 5.43518 7.47127 5.43518 7.90476 5.86866C8.33824 6.30214 8.33824 7.00496 7.90476 7.43844C7.47127 7.87192 6.76846 7.87192 6.33498 7.43844C5.9015 7.00496 5.9015 6.30214 6.33498 5.86866Z", fill: "currentColor" })), P = ({
  severity: n,
  text: h,
  onClose: d
}) => {
  const u = {
    success: Ce,
    information: ot,
    warning: ve,
    error: ve,
    neutral: st
  }[n];
  return /* @__PURE__ */ g(K, { children: [
    /* @__PURE__ */ c(G, { id: Z.__hash, children: Z }),
    /* @__PURE__ */ g("div", { className: `jsx-${Z.__hash} toast ${n}`, children: [
      d && /* @__PURE__ */ c("button", { "data-testid": "close-button", role: "button", onClick: d, className: `jsx-${Z.__hash} close-button`, children: /* @__PURE__ */ c(nt, {}) }),
      /* @__PURE__ */ c(u, { width: 20, height: 20, role: "img", className: `jsx-${Z.__hash}` }),
      /* @__PURE__ */ c("div", { className: `jsx-${Z.__hash} text ${n}`, children: h })
    ] })
  ] });
}, w = [`.toasts-container.jsx-3654587914{position:fixed;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;gap:10px;z-index:${et};}`, ".top.jsx-3654587914{top:10px;left:50%;-webkit-translate:-50%;translate:-50%;}", ".right-top.jsx-3654587914{top:10px;right:10px;}", ".right.jsx-3654587914{top:50%;right:10px;-webkit-translate:0 -50%;translate:0 -50%;}", ".right-bottom.jsx-3654587914{-webkit-flex-direction:column-reverse;-ms-flex-direction:column-reverse;flex-direction:column-reverse;bottom:10px;right:10px;}", ".bottom.jsx-3654587914{-webkit-flex-direction:column-reverse;-ms-flex-direction:column-reverse;flex-direction:column-reverse;bottom:10px;left:50%;-webkit-translate:-50%;translate:-50%;}", ".left-bottom.jsx-3654587914{-webkit-flex-direction:column-reverse;-ms-flex-direction:column-reverse;flex-direction:column-reverse;bottom:10px;left:10px;}", ".left.jsx-3654587914{top:50%;left:10px;-webkit-translate:0 -50%;translate:0 -50%;}", ".left-top.jsx-3654587914{top:10px;left:10px;}"];
w.__hash = "3654587914";
const be = ke(void 0), rt = ({
  children: n,
  customStyles: h = {
    className: "",
    styles: /* @__PURE__ */ c(K, {})
  }
}) => {
  const [d, u] = ue(0), [f, C] = ue([]), v = (t) => {
    C((A) => [...A.filter((y) => y.id !== t)]);
  }, M = ({
    severity: t,
    position: A = "right-top",
    text: y,
    duration: $ = 2e3,
    closable: I = !1,
    deletePrevious: T = !1
  }) => {
    u(d + 1), C(T ? () => [{
      severity: t,
      position: A,
      text: y,
      duration: $,
      closable: I,
      id: d,
      deletePrevious: T
    }] : (W) => [...W, {
      severity: t,
      position: A,
      text: y,
      duration: $,
      closable: I,
      id: d,
      deletePrevious: T
    }]), $ !== 1 / 0 && setTimeout(() => {
      v(d);
    }, $);
  }, _ = f.filter((t) => t.position === "top"), R = f.filter((t) => t.position === "right-top"), z = f.filter((t) => t.position === "right"), L = f.filter((t) => t.position === "right-bottom"), b = f.filter((t) => t.position === "bottom"), N = f.filter((t) => t.position === "left-bottom"), j = f.filter((t) => t.position === "left"), D = f.filter((t) => t.position === "left-top");
  return /* @__PURE__ */ g(be.Provider, { value: {
    emitToast: M
  }, children: [
    n,
    /* @__PURE__ */ c(G, { id: w.__hash, children: w }),
    h.styles,
    _.length > 0 && /* @__PURE__ */ c("div", { className: `jsx-${w.__hash} toasts-container top ${h.className}`, children: _.map((t) => /* @__PURE__ */ c(P, { severity: t.severity, text: t.text, onClose: t.closable ? () => v(t.id) : void 0 }, t.id)) }),
    R.length > 0 && /* @__PURE__ */ c("div", { className: `jsx-${w.__hash} toasts-container right-top`, children: R.map((t) => /* @__PURE__ */ c(P, { severity: t.severity, text: t.text, onClose: t.closable ? () => v(t.id) : void 0 }, t.id)) }),
    z.length > 0 && /* @__PURE__ */ c("div", { className: `jsx-${w.__hash} toasts-container right`, children: z.map((t) => /* @__PURE__ */ c(P, { severity: t.severity, text: t.text, onClose: t.closable ? () => v(t.id) : void 0 }, t.id)) }),
    L.length > 0 && /* @__PURE__ */ c("div", { className: `jsx-${w.__hash} toasts-container right-bottom`, children: L.map((t) => /* @__PURE__ */ c(P, { severity: t.severity, text: t.text, onClose: t.closable ? () => v(t.id) : void 0 }, t.id)) }),
    b.length > 0 && /* @__PURE__ */ c("div", { className: `jsx-${w.__hash} toasts-container bottom`, children: b.map((t) => /* @__PURE__ */ c(P, { severity: t.severity, text: t.text, onClose: t.closable ? () => v(t.id) : void 0 }, t.id)) }),
    N.length > 0 && /* @__PURE__ */ c("div", { className: `jsx-${w.__hash} toasts-container left-bottom`, children: N.map((t) => /* @__PURE__ */ c(P, { severity: t.severity, text: t.text, onClose: t.closable ? () => v(t.id) : void 0 }, t.id)) }),
    j.length > 0 && /* @__PURE__ */ c("div", { className: `jsx-${w.__hash} toasts-container left`, children: j.map((t) => /* @__PURE__ */ c(P, { severity: t.severity, text: t.text, onClose: t.closable ? () => v(t.id) : void 0 }, t.id)) }),
    D.length > 0 && /* @__PURE__ */ c("div", { className: `jsx-${w.__hash} toasts-container left-top`, children: D.map((t) => /* @__PURE__ */ c(P, { severity: t.severity, text: t.text, onClose: t.closable ? () => v(t.id) : void 0 }, t.id)) })
  ] });
}, it = () => {
  const n = Re(be);
  if (!n)
    throw new Error("useToastContext must be used inside ToastProvider");
  return n;
};
function ye(n) {
  var h, d, u = "";
  if (typeof n == "string" || typeof n == "number") u += n;
  else if (typeof n == "object") if (Array.isArray(n)) {
    var f = n.length;
    for (h = 0; h < f; h++) n[h] && (d = ye(n[h])) && (u && (u += " "), u += d);
  } else for (d in n) n[d] && (u && (u += " "), u += d);
  return u;
}
function lt() {
  for (var n, h, d = 0, u = "", f = arguments.length; d < f; d++) (n = arguments[d]) && (h = ye(n)) && (u && (u += " "), u += h);
  return u;
}
const _e = lt, at = ({
  analytics: n = {},
  labels: h = {},
  quantityInCart: d = 0,
  onClickOnAddProducts: u = () => {
  },
  quantityToBuyValue: f = 1,
  quantityToBuyOperator: C = ">=",
  showActivePromotionsBanner: v = !1,
  showActivePromotionsToast: M = !1,
  textToast: _ = null,
  addProductsOnClickOnText: R = !1,
  showButtonToAddToCart: z = !1,
  deviceType: L = "mobile"
}) => {
  var oe, se, re, ie, le, ae, ce, de, he;
  const b = Le(d), N = it(), j = L === "mobile", D = ((oe = h.promotionActive) == null ? void 0 : oe.single) || "", t = ((se = h.promotionActive) == null ? void 0 : se.multiple) || "", A = ((re = h.addProductsBanner) == null ? void 0 : re.toActivate) || "", y = ((ie = h.addProductsBanner) == null ? void 0 : ie.toActivateMore) || "", $ = ((le = h.addProductsBanner) == null ? void 0 : le.add) || "", I = ((ae = h.addProductsBanner) == null ? void 0 : ae.units) || "", T = ((ce = h.addProductsBanner) == null ? void 0 : ce.buttonText) || "", W = ((de = h.readyBanner) == null ? void 0 : de.text1) || "", U = ((he = h.readyBanner) == null ? void 0 : he.text2) || "", H = C === "=", r = C === ">=", s = Math.trunc(d / f), l = d % f, e = f - l, o = d % f === 0, E = H && (!d || !!e && e !== f) || r && !s, V = !E, we = H && !!s && !o, ne = () => {
    var O;
    u(e), (O = n == null ? void 0 : n.onClickOnAddProducts) == null || O.call(n, {
      quantityProductsAdded: e,
      quantityPromotionsTaken: s + 1
    });
  }, Se = () => {
    R && ne();
  }, je = () => {
    ne();
  };
  return te(() => {
    var O;
    (O = n == null ? void 0 : n.onRender) == null || O.call(n);
  }, []), te(() => {
    if (!M) return;
    const O = b.current;
    b.current = d, V && O < d && N.emitToast({
      severity: "success",
      position: j ? "top" : "right-top",
      duration: 5e3,
      text: /* @__PURE__ */ g("div", { className: `jsx-${x.__hash} toast-text`, children: [
        /* @__PURE__ */ c(G, { id: x.__hash, children: x }),
        _
      ] }),
      deletePrevious: !0
    });
  }, [V]), /* @__PURE__ */ g(K, { children: [
    /* @__PURE__ */ c(G, { id: x.__hash, children: x }),
    /* @__PURE__ */ g("div", { className: `jsx-${x.__hash} wholesale-banner-container`, children: [
      we && /* @__PURE__ */ g("div", { className: `jsx-${x.__hash} banner-active-promotions`, children: [
        /* @__PURE__ */ c("span", { className: `jsx-${x.__hash} quantity-promotions`, children: s }),
        " ",
        /* @__PURE__ */ c("span", { className: `jsx-${x.__hash}`, children: s === 1 ? D : t })
      ] }),
      E && /* @__PURE__ */ c("div", { className: `jsx-${x.__hash}`, children: /* @__PURE__ */ g("div", { className: `jsx-${x.__hash} banner-add-products`, children: [
        /* @__PURE__ */ c("div", { className: `jsx-${x.__hash} ` + (_e("discount-icon-container", {
          isDesktop: !j
        }) || ""), children: /* @__PURE__ */ c(tt, { width: j ? 16 : 20, height: j ? 16 : 20 }) }),
        /* @__PURE__ */ g("span", { className: `jsx-${x.__hash}`, children: [
          /* @__PURE__ */ g("span", { onClick: Se, "data-testid": "add-products-text", className: `jsx-${x.__hash} ` + (_e("add-products-text", {
            clickable: R
          }) || ""), children: [
            $,
            " ",
            e,
            " ",
            I
          ] }),
          " ",
          /* @__PURE__ */ c("span", { className: `jsx-${x.__hash} to-activate-promotion`, children: s === 0 ? A : y })
        ] }),
        z && /* @__PURE__ */ c("button", { onClick: je, "data-testid": "add-products-button", className: `jsx-${x.__hash} add-products-button`, children: T })
      ] }) }),
      v && V && /* @__PURE__ */ g("div", { className: `jsx-${x.__hash} banner-ready`, children: [
        /* @__PURE__ */ c(Ce, { width: 11, height: 8 }),
        /* @__PURE__ */ g("span", { className: `jsx-${x.__hash}`, children: [
          /* @__PURE__ */ c("span", { className: `jsx-${x.__hash} ready`, children: W }),
          " ",
          /* @__PURE__ */ c("span", { className: `jsx-${x.__hash}`, children: U })
        ] })
      ] })
    ] })
  ] });
}, ct = (n) => /* @__PURE__ */ c(rt, { children: /* @__PURE__ */ c(at, { ...n }) }), S = [`.container-recommended-products-ui.jsx-1557435305{width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;position:relative;font-family:${F};font-size:${Q};font-style:normal;font-weight:400;border-style:solid;border-width:1px;border-radius:4px;}`, `.container-recommended-products-ui.wholesale.jsx-1557435305{border-color:${ee};}`, `.container-recommended-products-ui.volume.jsx-1557435305{border-color:${k};}`, `.cross.jsx-1557435305{color:${Qe};display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin:0 1px;}`, `.upper-text.jsx-1557435305{box-sizing:border-box;width:100%;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;border-radius:2px 2px 0 0;padding:2px 4px;color:${J};line-height:12px;}`, `.upper-text.wholesale.jsx-1557435305{background-color:${ee};}`, `.upper-text.volume.jsx-1557435305{background-color:${k};}`, `.bottom-text.jsx-1557435305{background-color:${J};border-radius:0 0 4px 4px;padding:2px 4px;line-height:12px;}`, `.bottom-text.wholesale.jsx-1557435305{color:${ee};}`, `.bottom-text.volume.jsx-1557435305{color:${k};}`, ".bold-recommended-products-ui.jsx-1557435305{font-weight:700;}", `.price.jsx-1557435305{color:${k};font-family:${F};font-size:${Ye};font-style:normal;font-weight:700;margin-top:2px;line-height:28px;}`, `.unit.jsx-1557435305{font-family:${F};font-size:${Ke};font-style:normal;font-weight:400;line-height:16px;}`];
S.__hash = "1557435305";
const dt = (n) => /* @__PURE__ */ m.createElement("svg", { viewBox: "0 0 10 10", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...n }, /* @__PURE__ */ m.createElement("path", { d: "M8.09019 0.132675L9.82487 1.86735L6.66811 5.0241L9.91506 8.27105L8.22857 9.95754L4.98162 6.71059L1.82487 9.86735L0.0901935 8.13267L3.24695 4.97592L0 1.72897L1.68649 0.0424805L4.93344 3.28943L8.09019 0.132675Z", fill: "currentColor" })), ht = ({
  analytics: n = {},
  labels: h = {},
  discountPercent: d = 0,
  type: u = "volume",
  quantityToBuyOperator: f = ">=",
  quantityToBuyValue: C = 1
}) => {
  te(() => {
    var L;
    (L = n == null ? void 0 : n.onRender) == null || L.call(n);
  });
  const v = h.text1 || "", M = h.text2 || "", _ = h.units || "", R = h.from || "", z = h.each || "";
  return /* @__PURE__ */ g(K, { children: [
    /* @__PURE__ */ c(G, { id: S.__hash, children: S }),
    /* @__PURE__ */ g("div", { className: `jsx-${S.__hash} container-recommended-products-ui ${u}`, children: [
      /* @__PURE__ */ g("div", { className: `jsx-${S.__hash} upper-text ${u}`, children: [
        v,
        /* @__PURE__ */ c("span", { className: `jsx-${S.__hash} cross`, children: u === "volume" ? /* @__PURE__ */ c(dt, { width: 10, height: 10, "data-testid": "cross-icon" }) : "" }),
        M
      ] }),
      /* @__PURE__ */ g("div", { className: `jsx-${S.__hash} bottom-text ${u}`, children: [
        f === ">=" && /* @__PURE__ */ g("span", { className: `jsx-${S.__hash}`, children: [
          /* @__PURE__ */ g("span", { className: `jsx-${S.__hash} bold-recommended-products-ui`, children: [
            "-",
            d,
            "%"
          ] }),
          " ",
          R,
          " ",
          C,
          " ",
          _
        ] }),
        f === "=" && /* @__PURE__ */ g("span", { className: `jsx-${S.__hash}`, children: [
          /* @__PURE__ */ g("span", { className: `jsx-${S.__hash} bold-recommended-products-ui`, children: [
            "-",
            d,
            "%"
          ] }),
          " ",
          z,
          " ",
          C,
          " ",
          _
        ] })
      ] })
    ] })
  ] });
}, xt = {
  Badge: ht,
  Banner: ct
};
export {
  xt as Wholesale,
  xt as default
};
